import { AddCandidatesPageComponent } from "./add-candidates-page.component";
import { AddCandidatesModule } from "./addCandidates/add-candidates.module";
export const AddCandidatesPageModule = angular
    .module('addCandidatesPage', [AddCandidatesModule])
    .config(['$stateProvider',
    ($stateProvider) => {
        $stateProvider.state('missioncontrol.addCandidates', {
            url: '/addCandidates',
            component: AddCandidatesPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                jobId: null
            }
        });
    }
])
    .component(AddCandidatesPageComponent.selector, AddCandidatesPageComponent.component)
    .name;
//# sourceMappingURL=add-candidates-page.module.js.map